export const allEN = {
  PICK: 'Select answer',
  MATCH: 'Write your answer here',
  FILL: 'Answer must be selected',
  MISSING: 'The answers must be selected',
  WRITING: 'The forms have to be completed ',
  SPEAKING: 'To verify, you must record your answers'
}
